import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, NavLink, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { AuthGate } from './auth/AuthGate';
import { CalendarAuthProvider } from './auth/CalendarAuthContext';

const ProjectStatusPage = lazy(() => import('./pages/ProjectStatusPage'));
const AttendancePage = lazy(() => import('./pages/AttendancePage'));
const SalesPage = lazy(() => import('./pages/SalesPage'));

export default function App(): JSX.Element {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CalendarAuthProvider>
        <div className="app-shell">
          <nav className="global-nav" aria-label="主ナビゲーション">
            <div className="brand">
              <span className="brand-mark" aria-hidden>灯</span>
              <span className="brand-text">
                <span className="brand-title">灯文舎ダッシュボード</span>
                <span className="brand-subtitle">プロジェクト状況 / 出勤管理 / 売上管理</span>
              </span>
            </div>
            <ul className="nav-links">
              <li>
                <NavLink to="/project-status" className={({ isActive }) => (isActive ? 'is-active' : '')}>
                  プロジェクト状況
                </NavLink>
              </li>
              <li>
                <NavLink to="/attendance" className={({ isActive }) => (isActive ? 'is-active' : '')}>
                  出勤管理
                </NavLink>
              </li>
              <li>
                <NavLink to="/sales" className={({ isActive }) => (isActive ? 'is-active' : '')}>
                  売上管理
                </NavLink>
              </li>
            </ul>
          </nav>
          <Suspense fallback={
            <div className="page">
              <span className="loading-inline" role="status" aria-live="polite">
                <span className="loading-spinner" aria-hidden="true" />
                読み込み中…
              </span>
            </div>
          }>
            <Routes>
              <Route path="/" element={<Navigate to="/project-status" replace />} />
              <Route path="/project-status" element={<ProjectStatusPage />} />
              <Route
                path="/attendance"
                element={
                  <AuthGate>
                    <AttendancePage />
                  </AuthGate>
                }
              />
              <Route
                path="/sales"
                element={
                  <AuthGate>
                    <SalesPage />
                  </AuthGate>
                }
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
          <footer className="global-footer">
            <small>灯文舎 顧客管理ダッシュボード</small>
          </footer>
        </div>
        </CalendarAuthProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

function NotFound(): JSX.Element {
  return (
    <main className="page">
      <h1>ページが見つかりません</h1>
      <p className="empty-state">URL をご確認ください。</p>
    </main>
  );
}
